import { createContext, useContext } from "react";

interface StyleContextType {
    backgroundColor: string;
    setBrandingColors: (bgColor: string, textColor: string, primaryColor: string, buttonTextColor: string) => void;
}

export const StyleContext = createContext<StyleContextType | undefined>(undefined);


export const useStyle = () => {
    const context = useContext(StyleContext);
    if (!context) {
        throw new Error("useStyle must be used within a StyleProvider");
    }
    return context;
};